import{TestableLitElement as e}from"../../utils/components/testable-lit-element/testable-lit-element.js";class s extends e{}export{s as NjcBreadcrumbs};
